import { render, staticRenderFns } from "./FireAlarm.vue?vue&type=template&id=6352370c&scoped=true&"
import script from "./FireAlarm.vue?vue&type=script&lang=js&"
export * from "./FireAlarm.vue?vue&type=script&lang=js&"
import style0 from "./FireAlarm.vue?vue&type=style&index=0&id=6352370c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6352370c",
  null
  
)

export default component.exports